module.exports = __webpack_public_path__ + "static/media/logo-lockup.695e10d1.png";